import { render, staticRenderFns } from "./CharacterLooksForm.vue?vue&type=template&id=80bc2a10&scoped=true&"
import script from "./CharacterLooksForm.vue?vue&type=script&lang=js&"
export * from "./CharacterLooksForm.vue?vue&type=script&lang=js&"
import style0 from "./CharacterLooksForm.vue?vue&type=style&index=0&id=80bc2a10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc2a10",
  null
  
)

export default component.exports